import React, {Component} from 'react'
import {NavLink} from 'react-router-dom'

class Sidebar extends Component {

    randomQuestion = () => {
        this.props.randomQuestion(false);
    }

    render () {
        
        return (
            <div className="sidebar">
                <div className="navbutton" onClick = {this.randomQuestion}>Next</div>
                {/* <div>
                <NavLink exact activeClassName="hide" to='/review'  className = "navbutton">Review</NavLink>
                </div> */}
                <div className="navbutton" onClick = {this.props.showPTable}>
                Periodic Table
                </div>
                <div className="navbutton" onClick = {this.props.showAll}>
                Show All
                </div>

                <div className="w100">
                <NavLink exact activeClassName="hide" to='/' className="navbutton">Home</NavLink>
                </div>
            </div>
        );
    }
}

export default Sidebar;